import React, { ButtonHTMLAttributes } from 'react';

type ButtonVariant = 'primary' | 'ghost' | 'soft';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement | HTMLAnchorElement> {
  variant?: ButtonVariant;
  isLoading?: boolean;
  as?: 'button' | 'a';
  href?: string;
  target?: string;
}

export const Button: React.FC<ButtonProps> = ({ 
  children, 
  variant = 'primary', 
  isLoading,
  className = '',
  disabled,
  style,
  as: Component = 'button',
  href,
  ...props 
}) => {
  const spinner = (
    <span className="cab-spinner" />
  );

  const STYLES = `
    @keyframes cab-spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    .cab-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      width: 100%;
      height: 50px;
      border-radius: 100px;
      font-weight: 600;
      font-size: 15px;
      cursor: pointer;
      font-family: inherit;
      border: none;
      transition: 0.15s;
      text-decoration: none;
      box-sizing: border-box;
    }
    .cab-btn:disabled, .cab-btn.is-loading {
      cursor: not-allowed;
      opacity: 0.7;
    }
    .cab-btn-primary {
      background: var(--cab-violet);
      color: #fff;
    }
    .cab-btn-primary:hover:not(:disabled):not(.is-loading) {
      background: #2C1266;
    }
    .cab-btn-ghost {
      background: transparent;
      border: 1.5px solid var(--cab-violet);
      color: var(--cab-violet);
    }
    .cab-btn-ghost:hover:not(:disabled):not(.is-loading) {
      background: var(--cab-light);
    }
    .cab-btn-soft {
      background: var(--cab-purple-main);
      color: var(--cab-violet);
    }
    .cab-btn-soft:hover:not(:disabled):not(.is-loading) {
      background: var(--cab-d6);
    }
    .cab-spinner {
      width: 18px;
      height: 18px;
      border: 2px solid currentColor;
      border-bottom-color: transparent;
      border-radius: 50%;
      display: inline-block;
      animation: cab-spin 1s linear infinite;
    }
  `;

  const classes = `cab-btn cab-btn-${variant} ${isLoading ? 'is-loading' : ''} ${className}`.trim();

  if (Component === 'a' || href) {
    return (
      <a
        href={href}
        style={style}
        className={classes}
        {...(props as any)}
      >
        {isLoading ? spinner : children}
        <style>{STYLES}</style>
      </a>
    );
  }

  return (
    <button
      style={style}
      className={classes}
      disabled={disabled || isLoading}
      {...(props as any)}
    >
      {isLoading ? spinner : children}
      <style>{STYLES}</style>
    </button>
  );
};
